import React, { useEffect } from "react";
import { Box, Grid, Tooltip } from "@mui/material";
import { useTheme } from "@emotion/react";
import { useState } from "react";
import FileCopyIcon from '@mui/icons-material/FileCopy';
import EditIcon from '@mui/icons-material/Edit';
import { HiOutlineBookOpen } from "react-icons/hi";
import { SectionPaper, QuotePaper } from "./NotePapers";
import '../../App.css';
import IconButton from '@mui/material/IconButton';
import { deleteSection, deleteBookmark, updateSection, typeIndexToBookmarkIndex } from "./bookmarks";
import { StyledH5Heading } from "../style/StyledComponents";
import MarkdownPreview from "./MarkdownPreview";
import { getHeightByAspectRatio } from "../utils/videoUtils";
import { useHotkeys } from 'react-hotkeys-hook'
import { debounce } from "lodash";
import { exportToMarkdown } from "../Export"

const BookmarkComponent = ({embedId, title,
  bookmark, setBookmark, 
  gridRef,
  tabValue,
  setTabValue,
  handleTimelineClick,
  handleStartClick,
  handleLoopClick,
}) => {
  const [editMode, setEditMode] = useState(true);
  const theme = useTheme();
  const [height, setHeight] = useState(window.innerHeight - 250 + 'px'); // Set initial height

  useEffect(() => {
    const calculateHeight = () => {
      return window.innerHeight - 250 + 'px'; // Calculate height in JavaScript
    };

    const handleResize = debounce(() => {
      setHeight(calculateHeight()); // Update state with new height
    }, 100); // Debounce resize event by 100 milliseconds

    window.addEventListener('resize', handleResize);

    return () => {
      handleResize.cancel();
      window.removeEventListener('resize', handleResize);
    };
  }, []);


  const handleStepBack = () => {
    const index = typeIndexToBookmarkIndex('section', bookmark, tabValue);
    const prev_index = typeIndexToBookmarkIndex('section', bookmark, tabValue-1);
    if (index > 0 && bookmark[index].time - 1 > bookmark[prev_index].time ) {
      updateSection( bookmark, setBookmark, index, {time: bookmark[index].time-1})
    }
  }

  const handleStepForward = () => {
    const index = typeIndexToBookmarkIndex('section', bookmark, tabValue);
    if (index > 0 && index < bookmark.length -1 && bookmark[index].time + 1 < bookmark[index+1].time){
      updateSection( bookmark, setBookmark, index, {time: bookmark[index].time+1})
    }
  }

  // TODO: Refactor this code
  const handleStepBackWithIndex = (index) => {
    if (index > 0 && bookmark[index].time - 1 > bookmark[index - 1].time ) {
      updateSection( bookmark, setBookmark, index, {time: bookmark[index].time-1})
    }
  }

  const handleStepForwardWithIndex = (index) => {
    if (index > 0 && index < bookmark.length -1 && bookmark[index].time + 1 < bookmark[index+1].time){
      updateSection( bookmark, setBookmark, index, {time: bookmark[index].time+1})
    }
  }
  
  useHotkeys('space', () => {
    handleStartClick(tabValue);
  });

  useHotkeys('o', () => {
    handleLoopClick(tabValue);
  });

  useHotkeys('left', () => {
    handleTimelineClick(tabValue - 1);
  });

  useHotkeys('right', () => {
    handleTimelineClick(tabValue + 1);
  });


  useHotkeys('h', () => {
    handleStepBack();
  });

  useHotkeys('l', () => {
    handleStepForward();
  });

  const handleCopyMarkdown = (e) => {
      e.stopPropagation();
      exportToMarkdown(title? title : "", bookmark, embedId, true)
  }

  return (
  <>
      <Grid container item alignItems="center" justifyContent="space-between" style={{ width: '100%', paddingTop: "1rem"}}>
        <Grid item xs={true} style={{ display: 'flex', alignItems: 'center' }}>
          { editMode ? (
              <StyledH5Heading>Notes</StyledH5Heading>
          ) :(
            <>
              <StyledH5Heading>Notes Preview</StyledH5Heading>
              <Tooltip title="Copy the markdown code" size="md" arrow>
                <IconButton variant="contained" onClick={(e) => {handleCopyMarkdown(e)}} >
                    <FileCopyIcon />
                </IconButton>
              </Tooltip>
            </>
          )
          }
        </Grid>
        <Grid item >
          { editMode ? (
            <Tooltip title="Go to markdown preview mode." size="md" arrow>
              <IconButton 
                onClick={(e) => {
                  e.preventDefault();
                  setEditMode(false)
                }}
                variant="contained"
                sx={{
                  borderRadius: '4px', // Gives a slight rounded corner typical for rectangles
                  width: 30, // Specifies the width of the button
                  height: 35, // Specifies the height of the button
                  padding: '4px' // Adjust padding to scale the icon appropriately
                }}>
                  <HiOutlineBookOpen />
              </IconButton>
            </Tooltip>
          ) : (
            <Tooltip title="Go to notes mode." size="md" arrow>
              <IconButton 
                onClick={(e) => {
                  e.preventDefault();
                  setEditMode(true)
                }}
                variant="contained"
                sx={{
                  borderRadius: '4px', // Gives a slight rounded corner typical for rectangles
                  width: 30, // Specifies the width of the button
                  height: 35, // Specifies the height of the button
                  padding: '4px' // Adjust padding to scale the icon appropriately
                }}>
                  <EditIcon />
              </IconButton>
            </Tooltip>
          )}
        </Grid>
      </Grid>
    <Box 
      sx={{
        maxWidth: getHeightByAspectRatio(gridRef),
        maxHeight: height,
        borderBottom: 1, 
        borderColor: 'divider' ,
        overflow:'auto'
      }}
    >
      <Box
            sx={{
                width: '100%',        // Or a fixed width if you prefer
                height: '2px',        // Adjust thickness of the line
                backgroundColor: theme.palette.primary.main,  // Main theme color
            }}
        />
      <Box
            sx={{
                width: '100%',        // Or a fixed width if you prefer
                height: (editMode ? '10px' : '20px'),        // Adjust thickness of the line
            }}
        />
      {editMode ? (bookmark.slice(0, -1)
        .map((value, index) => (
          ( (value.type === "section") ?
              <SectionPaper
                index={index} 
                bookmarks={bookmark}
                setBookmarks={setBookmark}
                key={index}
                handleStartClick={handleStartClick}
                handleLoopClick={handleLoopClick}
                handleDeleteEvent={() => {deleteBookmark(bookmark, setBookmark, index)}}
                handleStepBack={handleStepBackWithIndex}
                handleStepForward={handleStepForwardWithIndex}
              /> : ( (value.type === "timestamp") ?
              < QuotePaper
                index={index} 
                bookmarks={bookmark}
                setBookmarks={setBookmark}
                handleStartClick={handleStartClick}
                handleDeleteEvent={() => {deleteBookmark(bookmark, setBookmark, index)}}
              /> : <></>
            )
          )
        )
      )) : (<>
        <MarkdownPreview 
          title={title}
          bookmark={bookmark}
          embedId={embedId}
        />
      </>)
    }
    </Box> 
  </>); 
}

export default BookmarkComponent;






